import React from 'react';
import { motion } from 'framer-motion';
import { Task } from '../types';
interface ProgressBarProps {
  tasks: Task[];
}
export function ProgressBar({
  tasks
}: ProgressBarProps) {
  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(t => t.revenueImpact !== null && t.repeatability !== null && t.timeSpent > 0).length;
  const percentage = totalTasks === 0 ? 0 : Math.round(completedTasks / totalTasks * 100);
  return <div className="sticky top-0 z-40 bg-cream/80 backdrop-blur-md py-4 border-b border-ink/5" data-id="element-102">
      <div className="max-w-3xl mx-auto px-6" data-id="element-103">
        <div className="flex justify-between items-end mb-2" data-id="element-104">
          <span className="font-bold text-ink" data-id="element-105">Scoring Progress</span>
          <span className="text-sm font-semibold text-ink/60" data-id="element-106">
            {completedTasks} of {totalTasks} tasks scored
          </span>
        </div>
        <div className="h-4 bg-ink/5 rounded-full overflow-hidden" data-id="element-107">
          <motion.div className="h-full bg-grape rounded-full" initial={{
          width: 0
        }} animate={{
          width: `${percentage}%`
        }} transition={{
          type: 'spring',
          stiffness: 50,
          damping: 15
        }} data-id="element-108" />
        </div>
      </div>
    </div>;
}